import '../../styles/_OTPInput.scss';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cryptoJS from 'crypto-js';
import { formatText, FormattedText } from 'core/i18n';
import {
    getRecordedJointHoldersConfirmationPage,
    recordedJointHoldersConfirmationPage,
    recordEvent,
    errorTag,
    PAGE_PRODUCT,
} from 'utilities/uTagging';
import UtagHelper from 'utilities/utagHelper';
import classNames from 'classnames';
import { ERROR_AL_ENVIAR_INVITACION } from 'constants/analyticsErrors';
import { PATH_JOINHOLDER_CONFIRMATION } from 'constants/uTagConstants/paths';
import { InputText } from 'components/inputText/inputText';
import { goToErrorsView, recordAndSavePage } from 'actions/errorViewNavigation';
import { actions as formActions } from 'react-redux-form';
import stepsActions from 'actions/stepsActions';
import optionsActions from 'actions/optionsActions';
import focusActions from 'actions/focusActions';
import ibanActions from 'actions/ibanActions';
import jointHoldersActions from 'actions/jointHoldersActions';
import jointHoldersStatusActions from 'actions/jointHoldersStatusActions';
import standByActions from 'actions/standByActions';
import createActions from 'actions/createActions';
import iconInfo from 'assets/icons/icon-info.svg';

class OtpViewHC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isValidOTP: false,
            loadingOTPCode: false,
            loadingReloadOTPCode: false,
        };

        this.handleValidateOtp = this.handleValidateOtp.bind(this);
        this.reloadOTPCode = this.reloadOTPCode.bind(this);
        this.handleOnCancel = this.handleOnCancel.bind(this);
        this.sendInvite = this.sendInvite.bind(this);
        this.updateStatus = this.updateStatus.bind(this);
        this.sendInviteNewHolder = this.sendInviteNewHolder.bind(this);
        this.sendPendingMails = this.sendPendingMails.bind(this);

        this.oldData = {};
    }

    componentDidMount() {
        const { userProfile, oldData, jointHoldersActions } = this.props;

        this.oldData = oldData;
        jointHoldersActions.getNewOtp(userProfile.accessToken);
    }

    handleOnCancel() {
        const { formActions, modelProp, handleOnCancel, oldData, userProfile, jointHoldersStatusActions } = this.props;
        const accessToken = userProfile.accessToken;

        formActions.change('userProfile.otpCodeHC', '');
        formActions.change(`userProfile.${modelProp}name`, oldData.name);
        formActions.change(`userProfile.${modelProp}lastName`, oldData.lastName);
        formActions.change(`userProfile.${modelProp}secondLastName`, oldData.secondLastName);
        formActions.change(`userProfile.${modelProp}docType`, oldData.docType);
        formActions.change(`userProfile.${modelProp}docNumber`, oldData.docNumber);
        formActions.change(`userProfile.${modelProp}email`, oldData.email);
        formActions.change(`userProfile.${modelProp}accountType`, oldData.accountType);
        formActions.change(`userProfile.${modelProp}openDebitCard`, oldData.openDebitCard);
        formActions.resetValidity('userProfile.otpCodeHC');
        jointHoldersStatusActions.statusHolders(accessToken);
        handleOnCancel();
    }

    updateStatus() {
        const { userProfile, formActions, jointHoldersStatusActions } = this.props;
        const accessToken = userProfile.accessToken;

        formActions.change('userProfile.otpCodeHC', '');
        formActions.resetValidity('userProfile.otpCodeHC');

        setTimeout(() => {
            formActions.change('userProfile.showOTP', false);
            formActions.change('userProfile.jointHolderEditable', false);
            jointHoldersStatusActions.statusHolders(accessToken);
        }, 1300);
    }

    sendInvite() {
        const {
            userProfile,
            jointHoldersActions,
            id,
            buildOldData,
            handleOnAdd,
            deleteHolder,
            actionOTP,
            updateHolder,
            formActions,
        } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const otpCode = userProfile.otpCodeHC ? userProfile.otpCodeHC.toUpperCase() : '';
        const accessToken = userProfile.accessToken;

        jointHoldersActions.verifyOtp({ otp: otpCode }, accessToken, (valid, error) => {
            this.setState({ loadingOTPCode: false });
            if (valid) {
                this.setState({ isValidOTP: true });
                formActions.setValidity('userProfile.otpCodeHC', { obsolete: true });
                formActions.setValidity('userProfile.otpCodeHC', { valid: true });

                if (actionOTP === 'edit') {
                    updateHolder(this.updateStatus);
                    buildOldData(id);
                    handleOnAdd();
                }

                if (actionOTP === 'delete') {
                    deleteHolder(this.updateStatus);
                }

                recordEvent(
                    PATH_JOINHOLDER_CONFIRMATION,
                    PAGE_PRODUCT,
                    'intervinientes',
                    'codigo otp correcto',
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
            } else if (error === 1) {
                formActions.setValidity('userProfile.otpCodeHC', { obsolete: false });
                recordEvent(
                    PATH_JOINHOLDER_CONFIRMATION,
                    PAGE_PRODUCT,
                    'intervinientes',
                    ERROR_AL_ENVIAR_INVITACION,
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
                errorTag({}, PATH_JOINHOLDER_CONFIRMATION, ERROR_AL_ENVIAR_INVITACION);
            } else {
                formActions.setValidity('userProfile.otpCodeHC', { valid: false });
                recordEvent(
                    PATH_JOINHOLDER_CONFIRMATION,
                    PAGE_PRODUCT,
                    'intervinientes',
                    ERROR_AL_ENVIAR_INVITACION,
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
                errorTag({}, PATH_JOINHOLDER_CONFIRMATION, ERROR_AL_ENVIAR_INVITACION);
            }
        });
    }

    sendInviteNewHolder() {
        const { userProfile, jointHoldersActions, id, buildOldData, handleOnAdd, formActions, addHolder } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const otpCode = userProfile.otpCodeHC ? userProfile.otpCodeHC.toUpperCase() : '';
        const accessToken = userProfile.accessToken;

        jointHoldersActions.verifyOtp({ otp: otpCode }, accessToken, (valid, error) => {
            this.setState({ loadingOTPCode: false });
            if (valid) {
                this.setState({ isValidOTP: true });
                addHolder(this.sendPendingMails);
                buildOldData(id);
                handleOnAdd();

                recordEvent(
                    PATH_JOINHOLDER_CONFIRMATION,
                    PAGE_PRODUCT,
                    'intervinientes',
                    'codigo otp correcto',
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
            } else if (error === 1) {
                formActions.setValidity('userProfile.otpCodeHC', { obsolete: false });
                recordEvent(
                    PATH_JOINHOLDER_CONFIRMATION,
                    PAGE_PRODUCT,
                    'intervinientes',
                    ERROR_AL_ENVIAR_INVITACION,
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
                errorTag({}, PATH_JOINHOLDER_CONFIRMATION, ERROR_AL_ENVIAR_INVITACION);
            } else {
                formActions.setValidity('userProfile.otpCodeHC', { valid: false });
                recordEvent(
                    PATH_JOINHOLDER_CONFIRMATION,
                    PAGE_PRODUCT,
                    'intervinientes',
                    ERROR_AL_ENVIAR_INVITACION,
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
                errorTag({}, PATH_JOINHOLDER_CONFIRMATION, ERROR_AL_ENVIAR_INVITACION);
            }
        });
    }

    sendPendingMails() {
        const { userProfile, jointHoldersActions, goToErrorsView } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const accessToken = userProfile.accessToken;

        jointHoldersActions.sendPendingInvitation(accessToken, valid => {
            if (!valid) {
                recordEvent(
                    PATH_JOINHOLDER_CONFIRMATION,
                    PAGE_PRODUCT,
                    'intervinientes',
                    ERROR_AL_ENVIAR_INVITACION,
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
                errorTag({}, PATH_JOINHOLDER_CONFIRMATION, ERROR_AL_ENVIAR_INVITACION);
                goToErrorsView({ errorMessage: ERROR_AL_ENVIAR_INVITACION });
            } else {
                this.updateStatus();
            }
        });
    }

    handleValidateOtp() {
        const { actionOTP } = this.props;

        this.setState({ loadingOTPCode: true });

        if (actionOTP === 'add') {
            this.sendInviteNewHolder();
        }

        if (actionOTP === 'edit' || actionOTP === 'delete') {
            this.sendInvite();
        }
    }

    buildOTPLoading() {
        return (
            <div className="joint-holder__otp-reload">
                <span className="icons--icon-otp-loading"></span>
            </div>
        );
    }

    buildOTPInput() {
        const { userProfile, userProfileForm, formActions, products, recordAndSavePage } = this.props;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        const iconClass = classNames(
            { 'icons--icon-check': this.state.isValidOTP },
            { hidden: !this.state.isValidOTP }
        );

        const reloadOTPCode = this.reloadOTPCode;

        if (!getRecordedJointHoldersConfirmationPage()) {
            const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

            recordedJointHoldersConfirmationPage();
            recordAndSavePage(
                PATH_JOINHOLDER_CONFIRMATION,
                userProfile.recordId,
                userProfile.userId,
                userProfile.product,
                products.get('productsDescription'),
                userProfile.promoCode ? userProfile.promoCode : '',
                JointHolderInfo,
                '',
                '',
                userProfile.investmentType,
                {
                    identificadorOnboarding: docNumberEncrypted,
                }
            );
        }

        return (
            <div className="prospects-gutter prospects-separator otp-block">
                <div className="form__input">
                    <label className="top-label">
                        <FormattedText value="otp-confirmationCode" />
                    </label>
                    <br />
                    <label className="sub-label">
                        <FormattedText value="otp-enterCode" />
                    </label>
                </div>
                <div className="promo-code__input row">
                    <div className="col-xs-9 col-sm-6">
                        <InputText
                            profileModel={'userProfile.otpCodeHC'}
                            id="otpCode"
                            type="text"
                            messagesError={{
                                valid: formatText('validation-otpInvalid'),
                                obsolete: formatText('validation-otpObsolete'),
                            }}
                            userProfile={userProfile}
                            formActions={formActions}
                            userProfileForm={userProfileForm}
                        />
                    </div>
                    <div className="col-xs-2 col-sm-2">
                        <span className={iconClass}></span>
                    </div>
                </div>
                <p className="prospects-disclaimer">
                    <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP1" />
                    <a
                        className="otp-block__link"
                        href="#"
                        onClick={event => {
                            event.preventDefault();
                            reloadOTPCode();
                        }}
                    >
                        <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP2" />
                    </a>
                    <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP3" />
                </p>
                <div className="otp-block__information-block">
                    <img src={iconInfo} />
                    <p>{formatText('otp-information')}</p>
                </div>
                <hr />
                <div className="inner-form__footer--buttons">
                    <button onClick={this.handleOnCancel} type="button" className="form__button form__button-negativeB">
                        {formatText('button-cancel')}
                    </button>
                    <button onClick={this.handleValidateOtp} className="form__button form__button-primaryB">
                        {formatText('button-confirm')}
                    </button>
                </div>
            </div>
        );
    }

    reloadOTPCode() {
        const { userProfile, formActions, jointHoldersActions } = this.props;
        const accessToken = userProfile.accessToken;

        formActions.change('userProfile.otpCodeHC', '');
        formActions.resetValidity('userProfile.otpCodeHC');
        this.setState({ loadingReloadOTPCode: true });

        jointHoldersActions.getNewOtp(accessToken, valid => {
            if (valid) {
                setTimeout(() => {
                    this.setState({ loadingReloadOTPCode: false, loadingOTPCode: false });
                }, 200);
            }
        });
    }

    render() {
        const buildOTP = this.state.loadingReloadOTPCode ? this.buildOTPLoading() : this.buildOTPInput();

        return <div className="joint-holder__otp-hc">{buildOTP}</div>;
    }
}

OtpViewHC.proptypes = {
    oldData: PropTypes.object,
};

OtpViewHC.defaultProps = {
    oldData: {},
};

module.exports.constructor = OtpViewHC;
module.exports.OtpViewHC = connect(
    state => ({
        userProfile: state.userProfile,
        extraData: state.extraData,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        options: state.options,
        focus: state.focus,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        ibanActions: bindActionCreators(ibanActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        jointHoldersActions: bindActionCreators(jointHoldersActions, dispatch),
        focusActions: bindActionCreators(focusActions, dispatch),
        standByActions: bindActionCreators(standByActions, dispatch),
        jointHoldersStatusActions: bindActionCreators(jointHoldersStatusActions, dispatch),
        createActions: bindActionCreators(createActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(OtpViewHC);
